import { RouterProvider } from "react-router-dom";
import { AppProviders } from "@app/providers";
import { router } from "@app/router/routes";
import { WelcomeGate } from "@features/welcome";
import { PersistentCommuteMapProvider } from "@features/search/components/maps/persistent-commute-map-provider";

export function App() {
  return (
    <AppProviders>
      <PersistentCommuteMapProvider>
        <WelcomeGate>
          <RouterProvider router={router} />
        </WelcomeGate>
      </PersistentCommuteMapProvider>
    </AppProviders>
  );
}
